// extracted by mini-css-extract-plugin
export default {"mediaPage":"Media_mediaPage__1rvbo"};